import React, {useState} from "react";
import {css} from "@emotion/react";

import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {PolygonType} from "../../../maps/types/PolygonType";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetailStats} from "../../types/IOfferDetail";
import {OfferType} from "../../types/OfferType";
import {getOfferBuildingPolygonOptions} from "../constants/offer_building_polygon_properties";
import {IOfferBuilding} from "../types/IOfferBuilding";

interface IProps {
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    offer: {
        geo_area: {
            coordinates: {
                coordinates: number[][][];
            };
        };
        id: number;
        configuration: {
            limited_presentation?: boolean;
            display_type: number;
            show_form_placeholder: boolean;
        };
        name: string;
        region: {
            country: Country;
        };
        type: OfferType;
        geo_point: {
            coordinates: [number, number];
        };
        vendor: {
            id: number;
            name: string;
            slug: string;
        };
        address: string;
        stats?: Pick<IOfferDetailStats, "ranges_area_max" | "ranges_area_min" | "rooms"> | null;
    };
    property?: {
        id: number;
        for_sale: boolean;
        building?: number;
    };
    offerBuildings?: IOfferBuilding[];
}

export const OfferMapModalContent = (props: IProps) => {
    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: props.offer.id,
            type: props.offer.type,
            stats: {
                ranges_area_min: props.offer.stats?.ranges_area_min,
                ranges_area_max: props.offer.stats?.ranges_area_max,
                rooms: props.offer.stats?.rooms
            }
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!props.property
    });

    const createOfferBuildingsPolygonList = () => {
        if (props.offerBuildings) {
            return props.offerBuildings.map(({geo_area, name, floors_count, id}) => ({
                coords: [geo_area.coordinates],
                options: getOfferBuildingPolygonOptions(id, props.property?.building),
                infoWindow: {
                    content: name
                },
                type: PolygonType.BLOCK,
                height: floors_count
            }));
        }
    };

    return (
        <div css={mapModalHolder}>
            <OpenStreetMapsWithPoi
                offer={props.offer}
                viewType={props.property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={props.area && props.area.polygon}
                detailPolygons={createOfferBuildingsPolygonList()}
                region={props.area && props.area.region}
                mapConfig={{fitBounds: true}}
                clusterMarkers
                customPoiMarkers={offerAdditionalPois}
                disablePoiSwitch={!getHasCountryPois(props.offer.region.country)}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                css={mapCustomStyles}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
                showTransportLines
            />
        </div>
    );
};

const mapModalHolder = css`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    padding-right: 0;
    position: relative;
`;

const mapCustomStyles = css`
    .leaflet-div-icon {
        background-color: transparent;
        border: none;
    }
`;
import React, {useState} from "react";
import {css} from "@emotion/react";

import {OpenStreetMapsWithPoi} from "../../../maps/components/map_with_poi/OpenStreetMapsWithPoi";
import {POI_DISTANCE_DEFAULT_VALUE} from "../../../maps/constants/pois_defaults";
import {useMapNearbyOffersPois} from "../../../maps/hooks/use_map_nearby_offers_pois";
import {PolygonType} from "../../../maps/types/PolygonType";
import {getHasCountryPois} from "../../../maps/utils/get_has_country_pois";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {IOfferDetailStats} from "../../types/IOfferDetail";
import {OfferType} from "../../types/OfferType";
import {getOfferBuildingPolygonOptions} from "../constants/offer_building_polygon_properties";
import {IOfferBuilding} from "../types/IOfferBuilding";

interface IProps {
    area?: {
        center: {
            coordinates: [number, number];
        };
        polygon: {
            coordinates: number[][][];
        };
        region: number;
    };
    offer: {
        geo_area: {
            coordinates: {
                coordinates: number[][][];
            };
        };
        id: number;
        configuration: {
            limited_presentation?: boolean;
            display_type: number;
            show_form_placeholder: boolean;
        };
        name: string;
        region: {
            country: Country;
        };
        type: OfferType;
        geo_point: {
            coordinates: [number, number];
        };
        vendor: {
            id: number;
            name: string;
            slug: string;
        };
        address: string;
        stats?: Pick<IOfferDetailStats, "ranges_area_max" | "ranges_area_min" | "rooms"> | null;
    };
    property?: {
        id: number;
        for_sale: boolean;
        building?: number;
    };
    offerBuildings?: IOfferBuilding[];
}

export const OfferMapModalContent = (props: IProps) => {
    const [poiDistance, setPoiDistance] = useState<number>(POI_DISTANCE_DEFAULT_VALUE);

    const {offerAdditionalPois, defaultPoiTypes, mapBottomSlot} = useMapNearbyOffersPois({
        baseOffer: {
            id: props.offer.id,
            type: props.offer.type,
            stats: {
                ranges_area_min: props.offer.stats?.ranges_area_min,
                ranges_area_max: props.offer.stats?.ranges_area_max,
                rooms: props.offer.stats?.rooms
            }
        },
        distance: poiDistance,
        showPropertyNumberOnMarker: !!props.property
    });

    const createOfferBuildingsPolygonList = () => {
        if (props.offerBuildings) {
            return props.offerBuildings.map(({geo_area, name, floors_count, id}) => ({
                coords: [geo_area.coordinates],
                options: getOfferBuildingPolygonOptions(id, props.property?.building),
                infoWindow: {
                    content: name
                },
                type: PolygonType.BLOCK,
                height: floors_count
            }));
        }
    };

    return (
        <div css={mapModalHolder}>
            <OpenStreetMapsWithPoi
                offer={props.offer}
                viewType={props.property ? ViewType.PROPERTY : ViewType.OFFER}
                polygon={props.area && props.area.polygon}
                detailPolygons={createOfferBuildingsPolygonList()}
                region={props.area && props.area.region}
                mapConfig={{fitBounds: true}}
                clusterMarkers
                customPoiMarkers={offerAdditionalPois}
                disablePoiSwitch={!getHasCountryPois(props.offer.region.country)}
                initialPoiTypes={defaultPoiTypes}
                mapBottomSlot={mapBottomSlot}
                css={mapCustomStyles}
                drawPoiDistance
                onDistanceChange={setPoiDistance}
                showTransportLines
            />
        </div>
    );
};

const mapModalHolder = css`
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    padding-right: 0;
    position: relative;
`;

const mapCustomStyles = css`
    .leaflet-div-icon {
        background-color: transparent;
        border: none;
    }
`;
